/** @file useSlotMaskUrl: the silhouette mask URL of the selected slot while it is empty (one request each). */
import { useEffect, useState } from 'react';
import type { ArtDeps } from './artTypes';

/** `slotMask(puppetId, key, 'silhouette').url` for an empty selected slot; null otherwise or on failure. */
export function useSlotMaskUrl(deps: Pick<ArtDeps, 'slotMask'>, puppetId: string | null, key: string | null, empty: boolean): string | null {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    setUrl(null);
    if (puppetId === null || key === null || !empty) return undefined;
    let live = true;
    deps.slotMask(puppetId, key, 'silhouette').then((r) => { if (live) setUrl(r.url); }, () => { if (live) setUrl(null); });
    return () => { live = false; };
  }, [deps, puppetId, key, empty]);
  return url;
}
